<template>
<div class="web-view">
  <div class="btn-box">
    <p class="box-title">税法税便问</p>
    <button class="btn-back" @click="goBack()">返回首页</button>
  </div>
  <iframe  class="content" :src="url" frameborder="0" width="100%" seamless="seamless" scrolling = "auto"></iframe>
</div>
  
</template>

<script>
export default {
  name: 'webView',
  data () {
    return {
      url: '',
      str: '?'
    }
  },
  mounted () {
    this.url = this.$route.query.url
    delete this.$route.query.url
    for(const key in this.$route.query){
      this.str = this.str + key + '=' + this.$route.query[key] + '&'
    }
    console.log(this.$route.query)
  },
  methods: {
    goBack() {
      this.$router.push('/' + this.str )
    }
  }
}
</script>

<style scoped>
.content{
  height: calc(100vh - 50px);
}
.btn-box{
  width: 100%;
  line-height: 50px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}
.box-title{
  order: 1;
  padding-left: 20px;
}
.btn-back{
  /* position: fixed; */
  /* float: right; */
  width: auto;
  height: 30px;
  line-height: 30px;
  margin: 10px 15px;
  border-radius: 5px;
  border: 1px solid #eeeeee;
}
</style>